






import {Component, Prop, Vue} from "vue-property-decorator";
import {PartnerTabs as PartnerTabsEnum} from "../enums/PartnerTabs";
import {PartnerTab} from "@share/catalog/interfaces/PartnerTab";

@Component({
  name: "PartnersTabs"
})
export default class PartnersTabs extends Vue {
  @Prop() value: PartnerTabsEnum;

  tabs: PartnerTab[] = [
      {
        localizationPath: 'exhibition.homeBtn',
        value: PartnerTabsEnum.Home
      },
      {
        localizationPath: 'exhibition.analyticsBtn',
        value: PartnerTabsEnum.Dashboard
      },
      {
        localizationPath: 'exhibition.analytics visitor',
        value: PartnerTabsEnum.Visitors
      }
  ];

  onTabClick(tab: PartnerTab) {
      this.$emit('input', tab.value);
      this.$emit('changed', tab.value);
  }
}
